import { Card } from '@/components/UI';
import type { ReadyAnalysisResult } from './types';

interface AnalysisSummaryStatsProps {
    readyAnalysis: ReadyAnalysisResult;
}

const AnalysisSummaryStats = ({ readyAnalysis }: AnalysisSummaryStatsProps) => {
    return (
        <Card className="bg-zinc-900 p-4">
            <div className="grid grid-cols-4 gap-4">
                <div>
                    <p className="text-zinc-400 text-sm">Entries Analyzed</p>
                    <p className="text-2xl font-semibold text-white">{readyAnalysis.entriesAnalyzed}</p>
                </div>
                <div>
                    <p className="text-zinc-400 text-sm">Parameters Found</p>
                    <p className="text-2xl font-semibold text-white">{Object.keys(readyAnalysis.parameters).length}</p>
                </div>
                <div>
                    <p className="text-zinc-400 text-sm">Positive Impact</p>
                    <p className="text-2xl font-semibold text-green-400">
                        {Object.values(readyAnalysis.parameters).filter((p: { impact: string }) => p.impact === 'positive').length}
                    </p>
                </div>
                <div>
                    <p className="text-zinc-400 text-sm">Negative Impact</p>
                    <p className="text-2xl font-semibold text-red-400">
                        {Object.values(readyAnalysis.parameters).filter((p: { impact: string }) => p.impact === 'negative').length}
                    </p>
                </div>
            </div>
        </Card>
    );
};

export default AnalysisSummaryStats;
